import React, {useEffect, useState} from 'react';
import {
    Paper, Table,
    TableBody, TableCell, TableContainer, TablePagination, TableRow

} from '@material-ui/core';

import {coreStyle, EnhancedTableHead} from "../../../styles/config";
import {parseQueryParams} from "../../../utils/helpers";
import Resource from "../../../crud/resource";
import Translate, {formatDate} from "../../../utils/utils";
import {Button, InputGroup} from "react-bootstrap";
import AutoComplete from "../../../widgets/AutoComplete";
import DatePicker from "../../../widgets/DatePicker";

const headCells = [
    {id: 'grower', label: <Translate id="TABLE.GROWER"/>},
    {id: 'buyer', label: <Translate id="TABLE.BUYER"/>},
    {id: 'shipping_date', label: <Translate id="TABLE.SHIPMENT_DATE"/>},
    {id: 'delivery_date', label: <Translate id="TABLE.DELIVERY_DATE"/>},
    {id: 'temperature', label: 'Criteria'},
    {id: 'rating', label: 'Rating'},
    {id: 'comments', label: 'Comments'},
    {id: 'variety', label: <Translate id="TABLE.VARIETY"/>},
];


export default function TemperatureReportList(props) {
    const {location: {search}, history} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;
    const [inspections, setInspections] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: queryParams.perPage,
    });
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [criteriaList, setCriteriaList] = useState([]);
    const [criteria, setCriteria] = useState(queryParams.criteria || []);
    const [selectedCriteria, setSelectedCriteria] = useState([]);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [growerList, setGrowersList] = useState([]);
    const [buyers, setBuyers] = useState([]);
    const [growers, setGrowers] = useState([]);
    const [selectedGrowers, setSelectedGrowers] = useState([]);
    const [isLoadingGrowers, setIsLoadingGrowers] = useState(false);
    const [buyersList, setBuyersList] = useState([]);
    const [selectedBuyers, setSelectedBuyers] = useState([]);
    const [isLoadingBuyers, setIsLoadingBuyers] = useState(false);
    const [isLoadingCriteriaList, setIsLoadingCriteriaList] = useState(false);
    const [isDownloading, setIsDownLoading] = useState(false);
    const [isDownloadComplete, setIsDownLoadComplete] = useState(false);

    useEffect(() => {
        const list = () => {
            const resource = new Resource('flowerShipment/criteria');
            setIsLoading(true);
            resource.index({
                perPage,
                page,
                startDate,
                buyers,
                criteria,
                growers,
                endDate,
            })
                .then(response => {
                    const {data: {data = {data: []}}} = response;
                    const paginationData = data;
                    setInspections(paginationData.data);
                    setPagination(paginationData);
                    setIsLoading(false);
                }).catch(err => {
                setIsLoading(false);
            });
        };

        list();
    }, [page, perPage, startDate, endDate, buyers, growers, criteria]);


    const handleChangePage = (e, page) => {
        setPage(++page);
        return history.push(`?page=${page}&perPage=${perPage}&growers=${selectedGrowers}&startDate=${startDate}&endDate=${endDate}&criteria=${criteria}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=1&perPage=${perPage}&growers=${selectedGrowers}&startDate=${startDate}&endDate=${endDate}&criteria=${criteria}`);
    };

    const extractIds = (list) => {
        return list.reduce((acc, obj) => {
            acc.push(obj.id);
            return acc;
        }, []);
    }

    const clear = () => {
        setStartDate(null);
        setEndDate(null);
        setSelectedStartDate(null);
        setSelectedEndDate(null);
        setBuyers([]);
        setGrowers([]);
        setCriteria([]);
        setSelectedCriteria([]);
        setPage(1);
    }

    const searchGrowers = (name) => {
        setIsLoadingGrowers(true);
        const resource = new Resource('grower');
        resource.index({name}).then(({data: {data: {data}}}) => {
            setIsLoadingGrowers(false);
            const selectedGrowerIds = extractIds(selectedGrowers);
            const growers = data.map((grower) => {
                return {'title': grower.name, 'id': grower.id};
            }).filter(grower => !selectedGrowerIds.includes(grower.id));
            setGrowersList(growers);
        }).catch(() => {
            setIsLoadingGrowers(false);
        });
    };

    const searchQualityCriteria = () => {
        setIsLoadingCriteriaList(true);
        const resource = new Resource('flowerShipment/criteriaList');
        resource.index().then(({data: {data}}) => {
            setIsLoadingCriteriaList(false);
            const selectedBuyerIds = extractIds(criteriaList);
            const list = data.map((criteria) => {
                return {'title': criteria.name, 'id': criteria.id};
            }).filter(criteria => !selectedBuyerIds.includes(criteria.id));
            setCriteriaList(list);
        }).catch(() => {
            setCriteriaList(false);
        });
    };

    const searchBuyers = (name) => {
        setIsLoadingBuyers(true);
        const resource = new Resource('buyer');
        resource.index({name}).then(({data: {data: {data}}}) => {
            setIsLoadingBuyers(false);
            const selectedBuyerIds = extractIds(selectedBuyers);
            const buyers = data.map((buyer) => {
                return {'title': buyer.name, 'id': buyer.id};
            }).filter(buyer => !selectedBuyerIds.includes(buyer.id));
            setBuyersList(buyers);
        }).catch(() => {
            setIsLoadingBuyers(false);
        });
    };

    const searchResults = () => {
        const buyers = extractIds(selectedBuyers);
        const growers = extractIds(selectedGrowers);
        const criteria = extractIds(selectedCriteria);

        setIsLoading(true);
        setBuyers(buyers);
        setGrowers(growers);
        setStartDate(selectedStartDate);
        setEndDate(selectedEndDate);
        setCriteria(criteria);
    }

    const download = () => {
        const resource = new Resource('report/flower/criteria/download');
        setIsDownLoading(true);
        resource.index({
            perPage,
            criteria,
            page,
            startDate,
            endDate,
        })
            .then(response => {
                setIsDownLoading(false);
                setIsDownLoadComplete(true);
                const {data} = response;
                let blob = new Blob([data], {type: "application/octetstream"});
                let a = document.createElement('a');
                a.href = window.URL.createObjectURL(blob);
                a.download = "criteria-report.xlsx";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(a.href);
                setTimeout(() => {
                    setIsDownLoadComplete(false);
                }, 2000);
            }).catch(err => {
            setIsDownLoading(false);
        });
    };

    return (
        <div className={coreStyle.root}>
            <InputGroup className="mb-3 input-group">
                <AutoComplete label={'Criteria'} handleInputChange={(e, value) => searchQualityCriteria(value)}
                              handleOnChange={(e, criteria) => setSelectedCriteria(criteria)} optionsList={criteriaList}
                              isLoading={isLoadingGrowers}/>

                <AutoComplete label={'Grower'} handleInputChange={(e, value) => searchGrowers(value)}
                              handleOnChange={(e, growers) => setSelectedGrowers(growers)} optionsList={growerList}
                              isLoading={isLoadingGrowers}/>

                <AutoComplete label={'Buyer'} handleInputChange={(e, value) => searchBuyers(value)}
                              handleOnChange={(e, buyers) => setSelectedBuyers(buyers)} optionsList={buyersList}
                              isLoading={isLoadingBuyers}/>
            </InputGroup>

            <InputGroup className="mb-6 input-group mb-2">
                <DatePicker label={'Start Date'} handleDateChange={setSelectedStartDate}/>
                <DatePicker label={'End Date'} handleDateChange={setSelectedEndDate}/>

                <InputGroup.Append>
                    <Button variant="outline-secondary" onClick={searchResults} disabled={false}>
                        <Translate id="SEARCH.SEARCH"/>
                        <i className="fa fa-search ml-sm-2" style={{"fontSize": ".7rem"}}/>
                    </Button>

                    <Button variant="outline-secondary" className="ml-sm-3" onClick={download} disabled={false}>
                        <Translate id="SEARCH.DOWNLOAD"/>
                        <i className={`fa ${isDownloading ? 'fa-spinner' : (isDownloadComplete ? 'fa-check-circle' : 'fa-download')} ml-sm-2`}
                           style={{"fontSize": ".7rem"}}/>
                    </Button>

                    <Button variant="outline-secondary" className="ml-sm-3" onClick={clear} disabled={false}>
                        <Translate id="SEARCH.CLEAR"/>
                        <i className="fa fa-trash ml-sm-2" style={{"fontSize": ".7rem"}}/>
                    </Button>
                </InputGroup.Append>
            </InputGroup>

            <Paper className={coreStyle.paper}>
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            rowCount={isLoading ? 0 : inspections.length}
                            headCells={headCells}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {inspections.map(inspection => {
                                const sanitizeComments = (comments) => {
                                    const list = comments.split(',');
                                    return list.map(comment => comment.replace('"', '').replace("{", '').replace("}", '').replace('"', '')).join(',');
                                }
                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={`${inspection.inspection_id}-${inspection.criteria}`}
                                    >
                                        <TableCell>{inspection?.grower}</TableCell>
                                        <TableCell>{inspection?.buyer}</TableCell>
                                        <TableCell>{formatDate(inspection?.shipping_date)}</TableCell>
                                        <TableCell>{formatDate(inspection?.delivery_date)}</TableCell>
                                        <TableCell>{inspection?.criteria}</TableCell>
                                        <TableCell className={`color-${inspection.rating_score}`}>{inspection?.rating}</TableCell>
                                        <TableCell>{sanitizeComments(inspection?.rating_comments)}</TableCell>
                                        <TableCell>{inspection?.variety}</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]} labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}
